'use client'

import Link from 'next/link'
import HeroDashboardAnimation from './HeroDashboardAnimation'

export default function HeroSection() {
  return (
    <section className="relative overflow-hidden bg-slate-900">
      {/* subtle radial glow behind animation */}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_60%_50%_at_60%_40%,rgba(59,130,246,0.08),transparent)]" />

      <div className="relative mx-auto grid max-w-6xl items-center gap-10 px-4 py-24 md:grid-cols-2 md:gap-16 md:py-32">
        {/* ── text column ──────────────────────────── */}
        <div className="order-2 md:order-1">
          <h1 className="text-4xl font-extrabold tracking-tight text-white md:text-5xl lg:text-6xl">
            <span className="whitespace-nowrap">Military Financial </span>
            <br />
            Modeling for Every Stage of Service
          </h1>

          <p className="mt-5 max-w-lg text-lg leading-relaxed text-slate-300 md:text-xl">
            Model pay, benefits, relocations, reenlistment, separation, and civilian transition with tools built for military life.
          </p>

          <div className="mt-10">
            <Link
              href="/signup"
              className="inline-flex h-12 items-center justify-center rounded-full bg-blue-600 px-8 text-sm font-semibold text-white shadow-lg shadow-blue-600/30 transition hover:bg-blue-500 hover:shadow-blue-500/40"
            >
              Run Your Scenario
            </Link>
          </div>
        </div>

        {/* ── animation column ─────────────────────── */}
        <div className="order-1 md:order-2">
          <HeroDashboardAnimation />
        </div>
      </div>
    </section>
  )
}
